import { Grid } from "@mui/material";
import NavigationDrawer from "../../components/drawer/NavigationDrawer";
import { NAVIGATION_DRAWER_TYPE_HR } from "../../components/drawer/NavigationDrawer/NavigationDrawer";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import { useTranslation } from "react-i18next";
import FullWidthTabs from "../../components/tabs/FullWidthTabs/FullWidthTabs";
import AnswerRegistryTab from "../../components/tabs/SurveyResultsTabs/AnswerRegistryTab";
import useHRService from "../../services/hrService";
import { useAsync } from "../../hooks/useAsync";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import SurveyResultsTab from "../../components/tabs/SurveyResultsTabs/SurveyResultsTab/SurveyResultsTab";



export default function HrSurveyResultsPage(props) {
  const { t } = useTranslation();

  const { pageName } = props;

  const {
    getAnswerFilteringData
  } = useHRService();

  const filteringData = useAsync(getAnswerFilteringData)




  return (
    <NavigationDrawer
      drawerType={NAVIGATION_DRAWER_TYPE_HR}
      pageName={pageName}
    >
      <DefaultPageWrapper titleKey={pageName}>
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          rowSpacing={1}
        >
          <LoaderWrapper showLoader={filteringData.loading}>
            <FullWidthTabs
              cleanFilters={true}
              items={
                [
                  {
                    label: t("page.hr_survey_results_page.answer_analyst"),
                    content: (
                      <AnswerRegistryTab
                        pageName={pageName}
                        filteringData={filteringData}
                      />
                    ),
                  },

                  {
                    label: t("page.hr_survey_results_page.survey_results"),
                    content: (
                      <SurveyResultsTab
                        filteringData={filteringData}
                      />
                    ),
                  },
                ]
              }
            />

          </LoaderWrapper>
        </Grid>
      </DefaultPageWrapper>
    </NavigationDrawer>
  );
}
